import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["associatedObjectId", "associatedObjectTypeId", "callingSource", "currentChannelId", "disableCalling", "isKnownVisitor", "onSelectedDropdownChange", "originalGenericChannelId", "subjectId", "inboxId", "threadId", "tabId"];
import ChannelSwitchDropdown from './ChannelSwitchDropdown';
import { useAllowedMessageChannelIds } from '../../../reply-editor/protected/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
function getSelectedEditorKey({
  allowedMessageChannelIds,
  originalGenericChannelId
}) {
  if (!allowedMessageChannelIds) {
    return null;
  }
  if (allowedMessageChannelIds.includes(originalGenericChannelId)) {
    return originalGenericChannelId;
  }
  return allowedMessageChannelIds[0];
}
export const ChannelTabs = _ref => {
  let {
      associatedObjectId,
      associatedObjectTypeId,
      callingSource,
      currentChannelId,
      disableCalling,
      isKnownVisitor,
      onSelectedDropdownChange,
      originalGenericChannelId,
      subjectId,
      inboxId,
      threadId,
      tabId
      // necessary for passing through tab data (also necessary for every component between this and Tabs)
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    allowedMessageChannelIds
  } = useAllowedMessageChannelIds({
    originalGenericChannelId
  });
  const selectedEditorKey = getSelectedEditorKey({
    allowedMessageChannelIds,
    originalGenericChannelId
  });
  if (!selectedEditorKey || !allowedMessageChannelIds || allowedMessageChannelIds.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ChannelSwitchDropdown, Object.assign({
    allowedMessageChannelIds: allowedMessageChannelIds,
    currentChannelId: currentChannelId,
    defaultChannelId: selectedEditorKey,
    associatedObjectId: associatedObjectId,
    associatedObjectTypeId: associatedObjectTypeId,
    callingSource: callingSource,
    hasCalling: !disableCalling,
    isKnownVisitor: isKnownVisitor,
    onSelectedDropdownChange: onSelectedDropdownChange,
    subjectId: subjectId,
    inboxId: inboxId,
    threadId: threadId,
    tabId: tabId
  }, rest));
};
ChannelTabs.displayName = 'ChannelTabs';